import { render, staticRenderFns } from "./AboutAndContact.vue?vue&type=template&id=b5aa6510&"
import script from "./AboutAndContact.vue?vue&type=script&lang=js&"
export * from "./AboutAndContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports